import {Answer} from './answer.model';

export class Question {
  public isTesting: boolean;
  public answers: Answer[];
  public questionText: string;
  public rightAnswer: Answer;
  checked: boolean;

  constructor(answers: Answer[], isTesting: boolean, questionText: string, rightAnswer: Answer) {
    this.isTesting = isTesting;
    this.answers = answers;
    this.questionText = questionText;
    this.rightAnswer = rightAnswer;
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/models/question.model.ts